<template>
	<li class='goods' :class='{height:firstOrder}' :style="{'width':noWidth ? 'auto':goodsWidth+'vw','height':goodsHegiht+'px','margin-left':marighLeft+'vw'}">
		<div class='goodswrap'>
			<a @click='select("/order/product/detail?sku="+product.sku)' :title="product.name">
				<div class="img" :style="{'height':goodsHegiht/hRatio+'px'}">
					<!-- <img :alt="product.name" class="imgtag" :src="product.image_path_big"  style='display:block'   > -->
					<img v-if='headImg' class="imgtag" :src='headImg' :style="{'width':imageWidth+'px','height':imageHeight+'px'}" :sku="product.sku">
					<img v-else class="errorImg" src='@/assets/order/errorImg1.png' :sku="product.sku">
					<!-- <img class="imgtag" v-lazyload="product.image_path_big" :key='product.image_path_big' :sku="product.sku"> -->
					<div class="activityflag">
						<span v-if='product.is_hot == 1' class="hot">熱銷<b>(Hot)</b></span>
						<span v-if='product.is_new == 1' class="hot">新品<b>(New)</b></span>
						<span v-if='product.is_promotion == 1' class="hot">促銷<b>(Promotion)</b></span>
					</div>
				</div>
			</a>
			<div class="m-skulist" v-if='noStockText(product)&&!isRead'>
				<div class="skuwrap">
					<span class="right-nostock show_nostock" v-html="noStockText(product)"></span>
				</div>
			</div>
			<div class='desc'>
				<p class="price" v-if='product.specproducts&&product.specproducts.length>0'>
					<span class="cur"><i>會員價 Member $P: </i>HK${{product.specproducts[0].price}}</span>
					<!-- <span class="pt" v-if="product.specproducts[0].pt>0">PT:{{product.specproducts[0].pt}}</span> -->
					<!-- <Stepper v-if='!noStockText(product)' :product="product"  :islrp='false' :animete='true' class='fk-cart-add' :iscart='2' :lrpedit='false' @showMoveDotFun='showMoveDotFun'  @showPromoCode='showPromoCode' ></Stepper> -->
				</p>
				<!-- <p class="price1" v-if='product.specproducts&&product.specproducts.length>0'>
					<span class="cur"><i>零售價:</i>HK${{product.specproducts[0].original_price}}</span>
				</p> -->
				<p class="specifications" v-if='product.specproducts&&product.specproducts.length>0'>
					<span class="marketprice">PV點數:{{product.specproducts[0].pv}}&nbsp;</span>
					<!-- <span class="marketprice">{{product.specproducts[0].specs[0].name}}:{{product.specproducts[0].specs[0].value}}</span> -->
				</p>
				<p class="price1" v-if='product.specproducts&&product.specproducts.length>0'>
					<span class="cur"><i>套裝編號SKU：</i>{{product.sku}}</span>
				</p>
				<!-- <p v-else>
					<span class="show_nostock">暫售完</span>
				</p> -->
				<div class="titlewrap">
					<a @click='select("/order/product/detail?sku="+product.sku)' class="title" :title="product.name">
						<h2 v-if='product.specproducts&&product.specproducts.length>0'>{{product.specproducts[0].name}}<br>{{product.specproducts[0].name_en}}</h2>
					</a>
				</div>
			</div>
			<div class='fastBuy' v-if='!noStockText(product)&&!isRead'>
				<buyCart :product="product" :islrp='false' :animete='true' :placement='placement' class='fk-cart-add' :iscart='4' :lrpedit='false' @showPromoCode='showPromoCode' @showSurveyfun='showSurveyfun' />
			</div>
		</div>
		<div class='firstOrder' v-if='(product.first_order&&firstOrder&&!noStockText(product)&&!isRead)'>
			<buyCart :product="product" :islrp='false' :animete='true' :placement='placement' class='fk-cart-add' :iscart='10' :lrpedit='false' @showPromoCode='showPromoCode' @confrimfirst='confrimfirst'  />
		</div>
	</li>

</template>

<script>
import buyCart from "@/components/order/buyCart";
import { mapState, mapMutations, mapActions } from "vuex";
import {
	cartInfoMethods,
	userInfoOrderMethods,
	systemConfigMethods,
} from "@/components/common/mixin";
import util from "@/config/util";
export default {
	data() {
		return {
			headImg: null,
			show: false,
			number: 1,
			imageWidth: 0,
			imageHeight: 0,
			goodsHegiht: 0,
			hRatio:1.5,
			wRatio:2.0,
		};
	},
	props: {
		product: {
			type: Object,
			default: function() {
				return {};
			}
		},
		noWidth:{
			type:Boolean,
			default:false,
		},
		goodsWidth: {
			type: Number,
			default: 30
		},
		marighLeft: {
			type: Number,
			default: 1.2
		},
		placement: {
			type: String,
			default: "right-end"
		},
		isRead: {
			type: Boolean,
			default: false
		},
		firstOrder: {
			type: Boolean,
			default: false
		}
	},
	created() {
		this.$nextTick(function() {});
	},
	mounted() {
		this.initData();
	},
	watch: {},
	mixins: [userInfoOrderMethods,systemConfigMethods],
	components: {
		buyCart
	},
	computed: {
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			forCustomer: state => state.order.forCustomer,
			warehouseInfo: state => state.order.warehouseInfo,
			sysConfig: state => state.common.sysConfig,
		}),
		warehouseList: function() {
			return [...((this.warehouseInfo || {}).value || [])];
		},
		nowDate:function(){
			let Config=this.systemDetail;
			if(Config?.now_time){
				return util.formatDate.dateFromStr(Config.now_time)
			}
			return util.realNowTime();
  		},
	},
	methods: {
		...mapActions([]),
		async initData() {
			var maxWidth = (document.body.clientWidth * this.goodsWidth) / 100;
			var goodsHegiht, maxHeight;
			
			if (this.isRead) {
				//this.wRatio=1.4;
				goodsHegiht = maxWidth * this.wRatio;
				maxHeight = goodsHegiht / this.hRatio;
				this.goodsHegiht = goodsHegiht;
			} else {
				this.hRatio=1.6;
				goodsHegiht = maxWidth * this.wRatio;
				if (goodsHegiht < 520) {
					goodsHegiht = 520;
				}
				maxHeight = goodsHegiht / this.hRatio;
				this.goodsHegiht = goodsHegiht;
			}

			if (!this.headImg) {
				let self = this;
				// console.log('sku',this.product.sku)
				let image = new Image();
				let product=this.product;
				image.src = product.image_path_big;
				image.onload = function() {
					self.headImg = image.src;
					// console.log(image.src)
					if (image.width < maxWidth && image.height < maxHeight) {
						self.imageWidth = image.width;
						self.imageHeight = image.height;
					} else {
						if (
							maxWidth / maxHeight <=
							image.width / image.height
						) {
							self.imageWidth = maxWidth;
							self.imageHeight =
								maxWidth * (image.height / image.width);
						} else {
							self.imageWidth =
								maxHeight * (image.width / image.height);
							self.imageHeight = maxHeight;
						}
					}
				};
			}
		},
		reload(){
			if (!this.imageWidth) {
				this.initData()
			}
		},
		noStock(product) {
			return (
				!(product.specproducts && product.specproducts.length > 0) ||
				!(product.control == 2 || product.control == 10)
			);
		},
		noStockText(product) {
			if(product.control==20){
				return "僅LRP用戶";
			}
			if (product.is_inventory == 10 && this.default_store_id != "501") {
				return "僅快遞(Only Delivery)";
			} else if (
				product.online_myo_begin &&
				product.online_myo_begin != "" &&
				this.nowDate <
					util.formatDate.dateFromStr(product.online_myo_begin)
			) {
				return "敬請期待(Coming Soon)";
			} else if (this.noStock(product)) {
				if (product.product_flag == 1) {
					return "售罄(Sold Out)";
				}
				return "暫售完(Out of Stock)";
			}
			return null; //正常銷售
		},
		select(string) {
			this.$router.push(string);
		},
		add() {
			if (this.number >= 10) {
				return;
			}
			this.number++;
		},
		remove() {
			if (this.number <= 1) {
				return;
			}
			this.number--;
		},
		showPromoCode(products) {
			if (products) {
				this.$emit("showPromoCode", products);
			}
		},
		showSurveyfun(model){
			this.$emit("showSurveyfun", model);
		},
		confrimfirst() {
			this.$emit("confrimfirst");
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/mixin";
@import "@/style/common";

.goods {
	position: relative;
	float: left;
	margin: 0 0px 14px;
	background-color: #fff;
	@include fontSize($font-size-13);
	&:hover .goodswrap {
		border: 1px solid $theme-color;
		box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
	}
	&:hover .img{
		img{
			transform: translateY(-10%);
			&.errorImg{
				transform:none;
			}
		}
	
	}
	&.colorsku {
		height: 387px;
	}
	a {
		display: block;
		color: #333;
	}
	&.height {
		//height: auto;
		margin-bottom: 50px;
	}
}
.fk-cart-add {
	position: relative;
}
.goodswrap {
	top: -1px;
	left: -1px;
	background-color: #fff;
	border: 1px solid #f3f3f3;
	// border-bottom: none;
	height: 100%;
	
	.img {
		height: 232px;
		// background-image: url("../../assets/order/errorImg.png");
		// position: relative;
		// background-size: cover;
	}
}
.activityflag {
	position: absolute;
	top: 15px;
	right: 15px;
	height: 42px;
	span {
		display: inline-block;
		float: right; //width: 36px;
		padding: 2px 4px; // line-height: 18px;
		margin-left: 4px;
		@include fontSize($font-size-13);
		color: #fff;
		text-align: center;
		margin-bottom: 5px;
		border-radius: 10px;
		b {
			font-weight: 500;
			@include fontSize($font-size-12);
		}
	}
	.hot {
		background-color: $theme-color;
	}
}
.img {
	position: relative;
	overflow: hidden;
	img {
		display: block;
		width: 100%;
		margin: auto;

		//position: absolute;
		// top: 50%;
		// transform: translateY(-50%);

		padding: 15px;
		transition: all 0.4s;
		&.errorImg{
				position: absolute;
				top: 20%;
				width: 100%;
				padding: 20px;
				//transition:none;
			}
		}
}
.desc {
	// width: 234px;
	padding: 0 14px 11px;
	.show_nostock {
		font-weight: bold;
		@include fontSize($font-size-22);
		line-height: 24px;
		padding: 3px 5px;
		background-color: #ccc;
		color: white;
		border-radius: 5px;
	}
	.right-nostock {
		display: inline-block;
		position: absolute;
		padding: 5px;
		right: 0;
	}
}
.price1 {
	font-size: 0;
	position: relative;
	font-style: normal;
	.cur {
		display: inline-block;
		margin-right: 2px; //font-weight: bold;
		@include fontSize($font-size-13);
	}
	i {
		@include fontSize($font-size-13);
		//color: #e31436;
		font-style: normal;
	}
}
.price {
	color: #fb5814;
	font-size: 0;
	position: relative;
	.cur {
		display: inline-block;
		margin-right: 2px;
		font-weight: bold;
		font-size: 22px;
		@include fontSize($font-size-22);
	}
	.pt {
		display: inline-block;
		margin-left: 5px;
		font-size: 14px;
		@include fontSize($font-size-14);
		color: #495060;
		float: right;
		margin-right: 20px;
	}
	i {
		font-size: 12px;
		@include fontSize($font-size-13);
		font-weight: bold;
		color: #fb5814;
		font-style: normal;
	}
	.marketprice {
		display: inline-block;
		margin: 0 5px;
		vertical-align: 2px;
		color: #999;
		font-size: 12px;
		@include fontSize($font-size-12);
	}
}
.specifications {
	margin-top: 3px;
}
.title {
	height: 40px;
	margin-top: 5px;
	// overflow: hidden;
	font-size: 13px;
	@include fontSize($font-size-14);
	line-height: 20px;
	word-wrap: break-word; // word-break: break-all;
	display: block;
	color: #333;
	&:hover {
		text-decoration: underline;
		color: $theme-color;
	}
	h2 {
		font-size: 100%;
	}
}
li.height .fastBuy {
	position: inherit;
}
.fastBuy {
	width: 100%;
	height: 35px;
	color: white;
	display: inline-block;
	padding: 0 10px 11px;
	vertical-align: middle;
	position: absolute;
	bottom: 0px;
}
.stepper {
	display: flex;
	float: left;
	.sub,
	.add {
		background-color: $theme-color;
		color: white;
		width: 24px;
		text-align: center;
		margin: 0 5px;
		border-radius: 5px;
	}
}
.rightBuy {
	float: right;
	// width: 105px;
	font-size: 12px;
	border-color: $theme-color;
	border-width: 1.5px;
	color: $theme-color;
	position: relative;
	top: -3px;
}
.m-skulist {
	position: relative; //width: 234px;
	padding: 0 14px 3px;
	.skuwrap {
		height: 32px;
		li {
			float: left;
			position: relative;
			width: 30px;
			height: 30px;
			margin-right: 4px;
			overflow: hidden;
			border: 1px solid #ddd;
			cursor: pointer;
			img {
				display: block;
				width: 30px;
				height: 30px;
			}
		}
		.show_nostock {
			font-weight: 600;
			@include fontSize($font-size-15);
			//font-size: 15px; // line-height: 24px;
			padding: 5px 8px;
			background-color: #ccc;
			color: white; //border-radius: 5px;
		}
	}
}
</style>